export default __webpack_public_path__ + "static/media/ALIADO_VALOR_AGREGADO.7d187048.png";